__turbopack_context__.v({
  "closeButton": "index-module__VOPSaa__closeButton",
  "content": "index-module__VOPSaa__content",
});
